import React from 'react';
import { AuditChangeType, AuditType, AuditAction } from '../data/SampleTrackingAuditData';
import { GenericTextBadge } from './GenericTextBadge';

interface AuditBadgeProps {
  type: AuditChangeType | AuditType | AuditAction;
  width?: number | undefined;
  height?: number | undefined;
}

const badgeStyles: Record<
  AuditChangeType | AuditType | AuditAction,
  {
    fill: string;
    stroke: string;
    text: string;
    label: string;
  }
> = {
  Create: {
    fill: '#d4edda',
    stroke: '#a3d9a5',
    text: '#155724',
    label: 'CREATE',
  },
  Change: {
    fill: '#d1ecf1',
    stroke: '#9dd2dc',
    text: '#0c5460',
    label: 'CHANGE',
  },
  Delete: {
    fill: '#f8d7da',
    stroke: '#e4aeb1',
    text: '#721c24',
    label: 'DELETE',
  },
  Undo: {
    fill: '#f8d7da',
    stroke: '#e4aeb1',
    text: '#721c24',
    label: 'UNDO',
  },
  'Check By': {
    fill: '#f9e79f',
    stroke: '#daa520',
    text: '#8b6c00',
    label: 'CHECK BY',
  },
  Order: {
    fill: '#d4edda',
    stroke: '#a3d9a5',
    text: '#155724',
    label: 'ORDER',
  },
  Tagging: {
    fill: '#f5a623',
    stroke: '#cc7000',
    text: '#994d00',
    label: 'TAGGING',
  },
};

export const AuditTypeBadge: React.FC<AuditBadgeProps> = ({ type, width = 80, height = 30 }) => {
  const style = badgeStyles[type];
  return (
    <GenericTextBadge
      fillColor={style.fill}
      strokeColor={style.stroke}
      textColor={style.text}
      displayText={style.label}
      width={width}
      height={height}
    />
  );
};
